module.exports = __webpack_public_path__ + "static/forager-dude-21ee0364b8a83d694d949ae10e9ce954.png";